import React from "react";

import Form from "../../../common/forms/Form";
import FormInput from "../../../common/forms/FormInput";
import ActionBtn from "../../../common/management/ActionBtn";

import { ValType } from "../../../utils/ValidationFunctions";

import styles from "./AddSchool.module.scss";

type Props = {
  title?: string;
  name_type: string;
  name?: string;
  img?: File;
  color?: string;
  handleName?: (val: string) => void;
  handleImage?: (val: File) => void;
  handleColor?: (val: string) => void;
  handleSubmit: () => void;
};

const AddTerm: React.FC<Props> = ({
  title,
  name_type,
  name,
  img,
  color,
  handleName,
  handleImage,
  handleColor,
  handleSubmit,
}) => {
  return (
    <div className={styles["f-addSchool"]}>
      <div className={styles["f-addSchool__title"]}>{`${title}を追加`}</div>
      <Form
        id="addSchool"
        handler={() => {}}
        className={styles["f-addSchool__form"]}
      >
        <div className={styles["f-addSchool__form-wrapper"]}>
          {handleName ? (
            <div
              className={`${styles["f-addSchool__form-input"]} ${styles["name"]}`}
            >
              <span className={styles["f-addSchool__form-input__label"]}>
                {`${title}名`}
              </span>
              <FormInput
                handler={(value) => {
                  if (value !== undefined && typeof value === "string") {
                    handleName(value);
                  }
                }}
                type="text"
                label=""
                name="term_name"
                placeholder={`${name_type}を入力`}
                style_class={styles["f-addSchool__form-input__text"]}
                initial_value={name}
              />
            </div>
          ) : null}
          {handleImage ? (
            <div className={styles["f-addSchool__form-input"]}>
              <span className={styles["f-addSchool__form-input__label"]}>
                画像
              </span>
              <div className={styles["f-addSchool__form-input__img"]}>
                {img !== undefined ? (
                  <img
                    src={
                      typeof img === "string" ? img : URL.createObjectURL(img)
                    }
                    className={styles["f-addSchool__form-value__img"]}
                  />
                ) : (
                  <span
                    className={styles["f-addSchool__form-value__img"]}
                  ></span>
                )}
                <FormInput
                  handler={(value) => {
                    if (value !== undefined && value instanceof File) {
                      handleImage(value);
                    }
                  }}
                  type="file"
                  label="画像を追加"
                  name="term_img"
                  id="term_img"
                  label_class={styles["f-addSchool__form-input__img-label"]}
                  val_type={ValType.File}
                />
              </div>
            </div>
          ) : null}
          {handleColor ? (
            <div className={styles["f-addSchool__form-input"]}>
              <span className={styles["f-addSchool__form-input__label"]}>
                カラー
              </span>
              <div className={styles["f-addSchool__form-input__color"]}>
                <FormInput
                  handler={(value) => {
                    if (value !== undefined && typeof value === "string") {
                      handleColor(value);
                    }
                  }}
                  type="color"
                  label=""
                  name="term_color"
                  style_class={styles["f-addSchool__form-input__color-style"]}
                  initial_value={color}
                />
                <span className={styles["f-addSchool__form-value__color"]}>
                  {color}
                </span>
              </div>
            </div>
          ) : null}
          <ActionBtn
            label="追加する"
            icon={["fal", "plus-circle"]}
            onClick={() => handleSubmit()}
          />
        </div>
      </Form>
    </div>
  );
};

export default AddTerm;
